import { createInstance, useMatomo } from '@jonkoops/matomo-tracker-react';
import { useRouterState } from '@tanstack/react-router';
import { type FC, type PropsWithChildren, useEffect, useRef } from 'react';

import { matomoSiteId, matomoUrl } from '@/lib/constants.ts';

// TODO: internalize this so we don't have to export this
export const matomoInstance = createInstance({
  urlBase: matomoUrl,
  siteId: matomoSiteId,
  userId: undefined, // optional, default value: `undefined`.
  disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
  heartBeat: {
    // optional, enabled by default
    active: true, // optional, default value: true
    seconds: 30, // optional, default value: `15
  },
  linkTracking: false, // optional, default value: true
  configurations: {
    // optional, default value: {}
    // any valid matomo configuration, all below are optional
    disableCookies: true,
    setSecureCookie: import.meta.env.MODE === 'production',
    setRequestMethod: 'POST',
  },
});

const MatomoTracker: FC<PropsWithChildren> = ({ children }) => {
  const { trackPageView, enableLinkTracking } = useMatomo();
  const routerState = useRouterState();
  const prevPath = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = routerState.location.pathname;
    if (prevPath.current !== currentPath) {
      prevPath.current = currentPath;
      trackPageView({});
    }
  }, [routerState.location.pathname, trackPageView]);

  enableLinkTracking();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default MatomoTracker;
